import { getAuthAxios } from "@artprov/design-system";

export async function getAutorizacionesService(id) {
    const url = id ? `/rendicion/${id}` : '/rendiciones'
    try {
        const response = await getAuthAxios("default").get(url)

        return response
    } catch (error) {
        throw error
    }
}

export async function getAdjuntosSolicitudService(id) {
    try {
        const response = await getAuthAxios("default").get(`/rendicion/${id}/detalle`);
        return response.data;
    } catch (error) {
        throw error
    }
}

export async function getAdjuntoPorId(id) {
    try {
        const response = await getAuthAxios("default").get(`/rendicion/detalle/file/${id}`)
        return response.data
    } catch (error) {
        console.error("Error consultando el adjunto" + error.message)
        return false
    }

}

export async function postGestionAutorizacion(action, id, text) {
    const actionToDo = action === "aceptar" ? "aprobado" : "rechazado"
    const bodyOptions = action === "rechazar" ? { observacion: text } : {}

    try {
        const response = await getAuthAxios("default").post(`/rendicion/autorizar/${actionToDo}`, {
            rg_id: id,
            ...bodyOptions
        })
        return response?.status == 200
    } catch (error) {
        return false
    }
}

export async function getIdicadoresSolicitud(id) {
    try {
        const response = await getAuthAxios("default").get(`/rendicion/${id}/resumen`)

        return response.data
    } catch (error) {
        return false
    }
}